import {createFileRoute} from '@tanstack/react-router'
import KotcView from "../../../kotc/KotcView.tsx";

export const Route = createFileRoute('/_app/kotc/')({
    component: RouteComponent,
})

function RouteComponent() {
    return <KotcView />
}
